import Vue from 'vue';
import Router from 'vue-router';
import store from '../store/index';
import Meta from 'vue-meta'; // https://github.com/nuxt/vue-meta
import { getLanguage, getParams } from '@/utils/common';

getParams();
let flowObject = store.getters.flowObject;

let views = {};
let routes = [
  {
    path: '/',
    redirect: `/${getLanguage()}`
  },
  { path: `/hc/${getLanguage()}/requests/new`, redirect: `/${getLanguage()}/requests/` },
  { path: '*', redirect: `/${getLanguage()}` }
];

var getPathName = (pageName, pageObject) => {
  if (pageName === 'home') {
    return '';
  }

  if (pageObject.meta) {
    if (pageObject.meta.categoryId) {
      let pathName;
      try {
        pathName = store.state.categories[pageObject.meta.categoryId].title;
      } catch (e) {
        console.warn(e);
        console.warn(`Category with ID ${pageObject.meta.categoryId} and pageName ${pageName} not found.`);
        console.log({pageObject, categories: store.state.categories});
        pathName = pageName;
      }
      pathName = pathName.replace(/ /g, '-');
      return `${pathName}`;
    }
  }
  return `${pageName}`;
};

// Building the Views and Routes Dynamically
let localeRoute = {
  path: '/:locale',
  component: {
    template: '<router-view />'
  },
  children: []
};
for (let pageName of Object.keys(flowObject.pages)) {
  views[pageName] = () => import(`@/views/${pageName}/${flowObject.pages[pageName].location}.vue`);
  localeRoute.children.push({
    path: getPathName(pageName, flowObject.pages[pageName]),
    name: pageName,
    meta: flowObject.pages[pageName].meta,
    component: views[pageName]
  });
}
routes.push(localeRoute);

let dynamicRouter = new Router({
  routes: routes,
  mode: 'history'
});

Vue.use(Router);
Vue.use(Meta);

export default dynamicRouter;
